import { render, staticRenderFns } from "./consent-questions.vue?vue&type=template&id=019b3b77&scoped=true&"
import script from "./consent-questions.vue?vue&type=script&lang=js&"
export * from "./consent-questions.vue?vue&type=script&lang=js&"
import style0 from "./consent-questions.vue?vue&type=style&index=0&id=019b3b77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019b3b77",
  null
  
)

component.options.__file = "consent-questions.vue"
export default component.exports